import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <p>Pepron 2024 | Skills</p>
    </div>
  );
};

export default Footer;
